import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, createBlock as _createBlock } from "vue";
import ResourceListRow from "@/components/admin/ResourceListRow.vue";
import { useRouter } from "vue-router";
import { ResourceType } from "@/model/enum/ResourceType";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ResourceList',
    props: {
        resources: { type: Array, required: true },
        type: { type: String, required: true }
    },
    setup(__props) {
        const props = __props;
        const router = useRouter();
        function rowClick(clickedResource) {
            router.push({ name: 'admin-resources-edit', params: { id: clickedResource.id.toString() } });
        }
        function createResource() {
            router.push({ name: 'admin-resources-new', params: { resourceType: props.type.toString() } });
        }
        return (_ctx, _cache) => {
            const _component_v_container = _resolveComponent("v-container");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_table = _resolveComponent("v-table");
            const _component_v_card = _resolveComponent("v-card");
            return (_openBlock(), _createBlock(_component_v_card, { class: "d-flex flex-wrap ma-0" }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_container, { class: "d-flex v-col-12 justify-start" }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_container, { class: "text-h4 text-start pa-0 ma-0" }, {
                                default: _withCtx(() => [
                                    (props.type == _unref(ResourceType).RESOURCE)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createTextVNode("Ressourcen")
                                        ], 64))
                                        : (props.type == _unref(ResourceType).ATTRIBUTE)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                _createTextVNode("Eigenschaften")
                                            ], 64))
                                            : _createCommentVNode("", true)
                                ]),
                                _: 1
                            }),
                            _createVNode(_component_v_btn, {
                                "data-cy": "create",
                                onClick: _cache[0] || (_cache[0] = ($event) => (createResource()))
                            }, {
                                default: _withCtx(() => [
                                    (props.type == _unref(ResourceType).RESOURCE)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createTextVNode("Neue Ressource anlegen")
                                        ], 64))
                                        : (props.type == _unref(ResourceType).ATTRIBUTE)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                _createTextVNode("Neue Eigenschaft anlegen")
                                            ], 64))
                                            : _createCommentVNode("", true)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_v_container, { fluid: true }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_table, {
                                class: "w-100",
                                "data-cy": "table"
                            }, {
                                default: _withCtx(() => [
                                    _createElementVNode("thead", null, [
                                        _createElementVNode("tr", null, [
                                            _cache[1] || (_cache[1] = _createElementVNode("th", null, "ID", -1)),
                                            _createElementVNode("th", null, [
                                                (props.type == _unref(ResourceType).RESOURCE)
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                        _createTextVNode("Ressource")
                                                    ], 64))
                                                    : (props.type == _unref(ResourceType).ATTRIBUTE)
                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                            _createTextVNode("Eigenschaft")
                                                        ], 64))
                                                        : _createCommentVNode("", true)
                                            ])
                                        ])
                                    ]),
                                    _createElementVNode("tbody", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.resources, (resource, index) => {
                                            return (_openBlock(), _createBlock(ResourceListRow, {
                                                class: "cursor-pointer",
                                                key: index,
                                                resource: resource,
                                                onClick: ($event) => (rowClick(resource)),
                                                "data-cy": "resourceRow"
                                            }, null, 8, ["resource", "onClick"]));
                                        }), 128))
                                    ])
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }));
        };
    }
});
